import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Routes, RouterModule } from '@angular/router';
import { SmsComponent } from './sms.component';
import { Modules, Pages, SmsModules } from '../core/constants/shared.constants';
import { SharedModule } from '../shared/shared.module';

const routes: Routes = [
  {
    path: 'overview',
    component: SmsComponent,
    loadChildren: () => import('../sms/dashboard/dashboard.module').then(mod => mod.DashboardModule),
    data: {
      module: Modules.Sms,
      menuTitle: Modules.Dashboard
    }
  },
  {
    path: Pages.SendRequest,
    component: SmsComponent,
    loadChildren: () => import('../sms/send-request/send-request.module').then(mod => mod.SendRequestModule),
    data: {
      module: Modules.Sms,
      menuTitle: SmsModules.SmsRequest
    }
  },
  {
    path: Pages.GetStatus,
    component: SmsComponent,
    loadChildren: () => import('../sms/get-info/get-info.module').then(mod => mod.GetInfoModule),
    data: {
      module: Modules.Sms,
      menuTitle: SmsModules.SmsInfo
    }
  },
  {
    path: Pages.Status,
    component: SmsComponent,
    loadChildren: () => import('../sms/sms-status/sms-status.module').then(mod => mod.SmsStatusModule),
    data: {
      module: Modules.Sms,
      menuTitle: SmsModules.SmsStatus
    }
  },
  {
    path: '',
    redirectTo: 'overview'
  },
  {
    path: '**',
    redirectTo: 'overview'
  }
]

@NgModule({
  declarations: [SmsComponent],
  imports: [
    CommonModule,
    SharedModule,
    RouterModule.forChild(routes)
  ],
  exports: [
    SmsComponent,
    RouterModule
  ]
})
export class SmsRoutingModule { }
